export function buildHealthConditionLegendItems(nodes = [], getNodeData = (node) => node) {
	let items = []

	for (let node of nodes) {
		let nodeData = getNodeData(node) || {}
		let tags = Array.isArray(nodeData.tags) ? nodeData.tags : []

		for (let tag of tags) {
			let existingItem = items.find((item) => item.color === tag.color && item.title === tag.title)
			if (existingItem) {
				existingItem.count++
				continue
			}

			items.push({
				count: 1,
				color: tag.color,
				title: tag.title,
			})
		}
	}

	items.sort((left, right) => right.count - left.count || left.title.localeCompare(right.title))
	return items
}

export function shouldShowLegendItemCount(items = []) {
	return items.some((item) => Number(item?.count) > 1)
}

export function formatLegendItemCountText(title, count, shouldShowCount) {
	if (!shouldShowCount || Number(count) <= 0) {
		return title
	}

	return `${count}x ${title}`
}
